function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 10,
  cy: 10,
  r: 10
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings/Account",
  transform: "translate(-232.000000, -112.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "settings",
  transform: "translate(8.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instelling-taal",
  transform: "translate(20.000000, 88.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "NL-flag",
  transform: "translate(204.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Oval",
  fill: "#D8D8D8",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#BA1A1A",
  mask: "url(#mask-2)",
  x: -0.242424242,
  y: 9.35547935e-14,
  width: 21.3333333,
  height: 6.66666667
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  fill: "#FFFFFF",
  mask: "url(#mask-2)",
  x: -0.242424242,
  y: 6.66666667,
  width: 21.3333333,
  height: 6.66666667
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#10459B",
  mask: "url(#mask-2)",
  x: -0.242424242,
  y: 13.3333333,
  width: 21.3333333,
  height: 6.66666667
}))))));
function SvgLangFlagNl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NL flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangFlagNl);
export default __webpack_public_path__ + "static/media/lang_flag_nl.be3487e53d70756151be2f80adaf79cc.svg";
export { ForwardRef as ReactComponent };